import React, { useRef, useState } from "react";
import Slider from "react-slick";
import "./ShopReels.css";

import { FaPlay, FaTimes } from "react-icons/fa";

const reels = [
  {
    id: 1,
    thumbnail: "/assets/thumbnails/thumb1.webp",
    video: "/assets/reels/reel1.mp4",
  },
  {
    id: 3,
    thumbnail: "/assets/thumbnails/thumb3.webp",
    video: "/assets/reels/reel3.mp4",
  },
];

export default function ShopReels() {
  const [playingId, setPlayingId] = useState(null);

  const videoRefs = useRef({});

  const stopAllVideos = () => {
    Object.values(videoRefs.current).forEach((video) => {
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    });

    setPlayingId(null);
  };

  const playVideo = (id) => {
    stopAllVideos();

    setPlayingId(id);

    setTimeout(() => {
      if (videoRefs.current[id]) {
        videoRefs.current[id].play();
      }
    }, 100);
  };

  const closeVideo = (id) => {
    if (videoRefs.current[id]) {
      videoRefs.current[id].pause();
      videoRefs.current[id].currentTime = 0;
    }

    setPlayingId(null);
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 600,
    autoplay: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,

    beforeChange: () => {
      stopAllVideos();
    },

    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          arrows: false,
        },
      },
    ],
  };

  return (
    <section className="shop-reels">
      <div className="shop-reels-container">
        <div className="shop-reels-top">
          <div className="left">
            <span>WATCH & BUY</span>
            <h2>Shop the Reels</h2>
            <p>
              See the drape in motion — tap any reel to play, then shop the saree.
            </p>
          </div>
        </div>

        <Slider {...settings}>
          {reels.map((item) => (
            <div key={item.id}>
              <div className="reel-card">
                {playingId === item.id ? (
                  <div className="video-wrapper">
                    <button
                      className="close-btn"
                      onClick={() => closeVideo(item.id)}
                    >
                      <FaTimes />
                    </button>

                    <video
                      ref={(el) => (videoRefs.current[item.id] = el)}
                      src={item.video}
                      className="reel-video"
                      controls
                      playsInline
                      autoPlay
                    />
                  </div>
                ) : (
                  <>
                    <img
                      src={item.thumbnail}
                      alt="Reel thumbnail"
                      className="reel-image"
                      loading="lazy"
                      width="400"
                      height="700"
                    />

                    <button
                      className="play-btn"
                      onClick={() => playVideo(item.id)}
                    >
                      <FaPlay />
                    </button>
                  </>
                )}
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
}